import dayjs from 'dayjs';

import { LIST_PRICE_COLLECTION_START_DATE } from 'features/cost-report/constants';
import { CostReportPriceType } from 'features/cost-report/types/common';

export const isListPriceDataIncomplete = (
  priceType: CostReportPriceType,
  fromDate: string | dayjs.Dayjs | Date | undefined | null
): boolean => {
  if (priceType !== CostReportPriceType.LIST) return false;
  if (!fromDate) return false;

  return dayjs(fromDate).isBefore(LIST_PRICE_COLLECTION_START_DATE, 'day');
};
